import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import download from "js-file-download";
import {Dialog} from "primereact/dialog";

import ReceiptPdfViewer from '../finance/receipt/ReceiptPdfViewerComponent';

const DocsListComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [displayViewer, setDisplayViewer] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [maximized, setMaximized] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if(entity === 'employee') {
        query = query + '&search[related_entity_id][operator]=%3D&search[related_entity_id][value]=' + id
      }
      if(entity === 'project') {
        query = query + '&search[related_entity_id][operator]=%3D&search[related_entity_id][value]=' + id
      }
      if(entity === 'contract') {
        query = query + '&search[related_entity_id][operator]=%3D&search[related_entity_id][value]=' + id
      }
      if(entity === 'candidate') {
        query = query + '&search[related_entity_id][operator]=%3D&search[related_entity_id][value]=' + id
      }
      apiCall('get', '/api/v2/document' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setDocs(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const viewDocument = (rowData) => {
    setLoading(true);
    let url = "";
    if (rowData.type === 'template') {
        url = "/api/v2/document/" + rowData.id + "/download/pdf";
    } else {
        url = "/api/v2/file/" + rowData?.file?.id + "/download";
    }
    axios.get(process.env.REACT_APP_API_HOST + url, {
        responseType: 'blob',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
        }
    })
    .then(response => {
        const blobUrl = URL.createObjectURL(response.data);
        setSelectedFile(blobUrl);
        setMaximized(true);
        setDisplayViewer(true);
    })
    .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
    })
    .finally(() => {
        setLoading(false);
    });
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getCategoryRelatedEntityValue = () => {
    if (props.backlink === '/hr/docs') {
      return 'App\\Entity\\Employee';
    }

    switch (entity) {
      case 'employee':
        return 'App\\Entity\\Employee';
      case 'project':
        return 'App\\Entity\\Project';
      case 'contract':
        return 'App\\Entity\\Contract';
      case 'offer':
        return 'App\\Entity\\Offer';
      default:
        return null;
    }
  };

  const categoryFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value ?? null}
        options={categoryOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={t('all')}
        showClear
        optionLabel="label"
        optionValue="value"
        appendTo={document.body}
        className="p-column-filter"
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className='p-mr-2'
                tooltip="Gyorsnézet" tooltipOptions={{position: 'left'}}
                onClick={() => viewDocument(rowData)}
                />
        <Button icon="pi pi-download" className="p-button-secondary p-mr-2"
                tooltip={t('download')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if(rowData.type === 'template') {
                    setLoading(true);
                    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/document/" + rowData.id + "/download/pdf", {
                      responseType: 'blob',
                      params: {},
                      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
                    })
                      .then(response => {
                        download(response.data, rowData.name + '.pdf')
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                      .finally(() => {
                        setLoading(false);
                      })
                  }
                  if(rowData.type === 'uploaded') {
                    setLoading(true);
                    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/file/" + rowData?.file?.id + "/download", {
                      responseType: 'blob',
                      params: {},
                      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
                    })
                      .then(response => {
                        download(response.data, rowData?.file?.filename)
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                      .finally(() => {
                        setLoading(false);
                      })
                  }
                }}
        />
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/document/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderDocsList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderDocsList])

  useEffect(() => {
    const relatedEntity = getCategoryRelatedEntityValue();
    let query = '/api/v2/document-category?rows=9999';

    if (relatedEntity) {
      query +=
        '&search[related_entity][operator]=%3D' +
        '&search[related_entity][value]=' +
        encodeURIComponent(relatedEntity);
    }

    apiCall('get', query)
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setCategoryOptions(
          items.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [entity]);

  // useEffect(() => {
  //   if (entity !== 'docs' && id) {
  //     setLazyParams({
  //       ...lazyParams,
  //       filters: {
  //         ...lazyParams.filters,
  //         related_entity_id: {value: id, matchMode: 'equals'},
  //       }
  //     })
  //   }
  // }, [])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={docs} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="document_category.related_entity" header={t('columnEntity')} sortable filter body={(rowData) => {
          return(
            <>{t(rowData.document_category.related_entity.replace('App\\Entity\\','').toLowerCase())}</>
          )
        }}></Column>
        <Column
          field="document_category.name"
          header={t('columnCategory')}
          sortable
          filter
          filterField="document_category"
          filterMatchMode="equals"
          filterElement={categoryFilterTemplate}
        ></Column>
        <Column field="document_template.name" header={t('columnTemplate')} sortable filter></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      <Dialog 
        header={t('documentView')} 
        visible={displayViewer} 
        maximized={maximized}
        onMaximize={(e) => setMaximized(e.maximized)}
        style={{ width: '70vw' }} 
        onHide={() => {
            setDisplayViewer(false);
            if (selectedFile) URL.revokeObjectURL(selectedFile);
            setSelectedFile(null);
        }}
        maximizable
      >
        {selectedFile && <ReceiptPdfViewer file={selectedFile} height={800} />}
      </Dialog>
    </>
  )
}
export default withTranslation('common')(DocsListComponent);
